export default "__VITE_ASSET__C4msx9pq__"